import { Injectable } from "@angular/core";
import { HttpContext } from "@angular/common/http";
import { Observable } from 'rxjs';
import { siQuoteUrls } from '../../../environments/environment';
import { BaseHttpService } from "./base-http.service";
import {
    ProductPromotionResponse, ProductPromotionRequest,
  ProductPromotionStatusResponse, ProductPromotionStatusRequest,
  ProductPromotionDropDownDataRequest, ProductPromotionDropDownDataResponse
} from "../../models/dtos";
import { withLocalErrorHandling } from "../../core/errors/http-context-tokens";


@Injectable({
  providedIn: 'root'
})
export class ProductPromotionService {
  
  constructor(private readonly baseHttp: BaseHttpService) { }

  submitProductPromotionRequest(requestBody: ProductPromotionRequest): Observable<ProductPromotionResponse> {
    const context: HttpContext = withLocalErrorHandling();
    return this.baseHttp.post<ProductPromotionResponse>(`${siQuoteUrls.productPromotion}/SubmitProductPromotionRequest`, requestBody, { context });
  }


  getProductPromotionStatus(requestBody: ProductPromotionStatusRequest): Observable<ProductPromotionStatusResponse> {
    return this.baseHttp.post<ProductPromotionStatusResponse>(`${siQuoteUrls.productPromotion}/GetProductPromotionStatus`, requestBody);
  }

  getProductPromotionDropDownData(requestBody: ProductPromotionDropDownDataRequest): Observable<ProductPromotionDropDownDataResponse> {
    return this.baseHttp.post<ProductPromotionDropDownDataResponse>(`${siQuoteUrls.productPromotion}/GetProductPromotionDropDownData`, requestBody);
  }

  
}
